import { Profile } from "./Profile";
import Widgets from "./Widgets";
import { getThemeColor } from "Store/reducers/Auth/AuthSlice";
import { useSelector } from "react-redux";

export const DigitalProfile = () => {
  const themeColorString = useSelector(getThemeColor);
  let themeColor;

  try {
    themeColor = JSON.parse(themeColorString);
  } catch (error) {
    console.error("Failed to parse themeColor:", themeColorString, error);
    // Fallback to default theme
    themeColor = {
      background: "#E6E6E6",
      text: "#333C4D",
      btnBg: "#333C4D",
      btnText: "#ffffff",
    };
  }
  return (
    <div
      className="dashboard-main-container flex flex-col lg:flex-row min-h-screen p-4 sm:p-6 md:p-8 lg:p-12 xl:p-16"
      style={{ backgroundColor: themeColor?.background }}
    >
      {/* Profile Section */}
      <div className="w-full lg:w-2/5 xl:w-1/3 mb-6 lg:mb-0 lg:pr-6">
        <Profile />
      </div>

      {/* Widgets Section */}
      <div className="flex flex-col items-start w-full lg:w-3/5 xl:w-2/3 lg:pl-6">
        <Widgets />
      </div>
    </div>
  );
};
